import {
  AfterViewInit, ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  ViewChild,
  ViewChildren
} from '@angular/core';
import CooperationEventModel from '../../../model/cooperationEvent.model';
import CooperationModel from '../../../model/cooperation.model';
import {MatDialog} from '@angular/material/dialog';
import EventService from '../../../api/event/event.service';
import * as moment from 'moment';
import {MatSnackBar} from '@angular/material/snack-bar';
import DoingModel from '../../../model/doing.model';
import DoingService from '../../../api/doing/doing.service';
import {BehaviorSubject, Subject, Subscription} from 'rxjs';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import NoteModel from '../../../model/note.model';
import AudioHelper from '../../../helper/audio.helper';
import UpdateService from '../../../api/update.service';
import {environment} from '../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {ConfirmDialogComponent, ConfirmDialogModel} from '../../dialogs/confirm-dialog/confirm-dialog.component';
import addBusinessDays from "../../util/addBusinessDays";
import dayjs from "dayjs";
import UserModel from "../../../model/user.model";
import UserService from "../../../api/user/user.service";

@Component({
  selector: 'app-doing',
  templateUrl: './doing.component.html',
  styleUrls: ['./doing.component.scss']
})
export class DoingComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() doing: DoingModel;
  @Input() isSubdoing = false;
  @Output() followUpAdded = new EventEmitter<DoingModel>();
  @Output() removed = new EventEmitter<DoingModel>();

  @ViewChild("pickerToggle", { read: ElementRef}) followUpPicker: ElementRef;

  private textSubject = new BehaviorSubject<string>('');
  public text$ = this.textSubject.asObservable();

  public followUpDate;

  public predecessors: DoingModel[];

  public days: number;
  public now = new Date();

  @Input() showDetails = false;
  public editMode = false;

  private changeSubscribtion: Subscription;

  private loadingSubject = new BehaviorSubject<boolean>(false);
  public loading$ = this.loadingSubject.asObservable();

  public defaultFollowUpDate = null;

  public followUpDoing: DoingModel;

  public logo = null;

  public user: UserModel;

  constructor(private dialog: MatDialog, private doingService: DoingService, private ref: ChangeDetectorRef,
              private userService: UserService,
              private snackBar: MatSnackBar, private updateService: UpdateService) { }

  ngOnInit(): void {
    this.changeSubscribtion = this.updateService.subscribeToChanges('doings').subscribe(result => {
      if(result && result.id && result.id == this.doing.id) {
        Object.assign(this.doing, result.payload);
      }
    });

    this.logo = this.getLogo();
    this.user = this.userService.getUserSnapshot();

    let followUp = addBusinessDays(new Date(), 3);
    followUp.setHours(8, 0, 0);

    this.followUpDoing = {
      cooperation: this.doing.cooperation,
      customer: this.doing.customer,
      markedUser: this.doing.markedUser,
      followUp: followUp,
      text: '',
      state: this.doing.state
    }
    this.doing.followUp = new Date(this.doing.followUp);

    if(!this.isSubdoing) {
      this.updateService.subscribe<any>('doing-remove').subscribe(event => {
        if(event.data) {
           let successor = null;
           let currentDoing = this.doing;
           while(currentDoing != null) {
             if(currentDoing.id == event.data.id) {
               if(successor) {
                 successor.predecessor = currentDoing.predecessor;
               } else {
                 this.doing = currentDoing.predecessor;
               }
               break;
             } else {
               successor = currentDoing;
               currentDoing = currentDoing.predecessor;
             }
           }
        }
      });
    }
  }

  ngOnDestroy() {
    this.changeSubscribtion.unsubscribe();
  }

  ngAfterViewInit() {
    this.refresh();
  }

  public refresh() {
    if(this.doing) {
      let predecessor = this.doing.predecessor;
      this.predecessors = [];
      while(predecessor) {
        this.predecessors.push(predecessor);
        predecessor = predecessor.predecessor;
      }
    }
  }

  public checkboxClicked() {
    if (this.doing.checked) {
      this.doingService.uncheck(this.doing).subscribe(result => {
        if(result) {
          this.doing.checked = null;
          const audio = new AudioHelper();
        }
      });
    } else {
      this.doingService.check(this.doing).subscribe(result => {
        if(result) {
          this.doing.checked = new Date();
          const audio = new AudioHelper();
          audio.playSuccess();
        }
      });
    }
  }

  public onBlur() {
    const text = this.textSubject.getValue();
    if(text.trim() != '' && text != this.doing.text) {
      this.doing.text = text;
      this.doingService.update(this.doing).subscribe(result => {
        this.snackBar.open('Doing aktualisiert');
      });
    }
  }

  public addFollowUp(doing: DoingModel) {
    if(this.loadingSubject.getValue()) { return; }

    this.loadingSubject.next(true);
    this.doingService.createFollowUp(doing, this.doing).subscribe(result => {
      Object.assign(this.doing, result);
      this.ref.markForCheck();
      this.followUpAdded.emit(this.doing);
      this.showDetails = false;
      this.loadingSubject.next(false);
      let followUp = addBusinessDays(new Date(), 3);
      followUp.setHours(8, 0, 0);
      this.followUpDoing = {
        text: '',
        state: result.state,
        markedUser: result.markedUser,
        customer: result.customer,
        cooperation: result.cooperation,
        followUp: followUp
      };
    }, error => {
      this.snackBar.open('Fehler beim Hinzufügen des Follow-Ups');
      this.loadingSubject.next(false);
    });
  }

  public deleteDoing() {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: {
        title: 'Doing löschen',
        message: 'Soll das Doing unwiderruflich gelöscht werden?'
      } as ConfirmDialogModel
    });
    dialogRef.afterClosed().subscribe(dialogResult => {
      if (dialogResult) {
        this.doingService.delete(this.doing).subscribe(result => {
          if(result) {
            if(this.doing.predecessor != null) {
              Object.assign(this.doing, this.doing.predecessor);
            } else {
              this.removed.emit(this.doing);
            }
          } else {
            this.snackBar.open('Fehler beim Löschen des Doings');
          }

        });
      }
    });

  }

  public deletedHandler(doing: DoingModel) {
    let index = this.predecessors.indexOf(doing);
    if (index >= 0) {
      this.predecessors.splice(index, 1);
    }
  }

  public editDoing() {
    this.editMode = true;
  }

  public success() {
    const oldState = this.doing.state;
    this.doing.state = 'success';
    this.doingService.update(this.doing).subscribe(result => {
      this.snackBar.open('Doing geschlossen');
    }, error => {
      this.doing.state = oldState;
      this.snackBar.open('Fehler beim Aktualisieren');
    });
  }

  public reopen() {
    const oldState = this.doing.state;
    this.doing.state = 'new';
    this.doingService.update(this.doing).subscribe(result => {
      this.snackBar.open('Doing geöffnet');
    }, error => {
      this.doing.state = oldState;
      this.snackBar.open('Fehler beim Aktualisieren');
    });
  }

  public fail() {
    const oldState = this.doing.state;
    this.doing.state = 'fail';
    this.doingService.update(this.doing).subscribe(result => {
      this.snackBar.open('Doing geschlossen');
    }, error => {
      this.doing.state = oldState;
      this.snackBar.open('Fehler beim Aktualisieren');
    });
  }

  public updateDoing(doing: DoingModel) {
    this.editMode = false;
    this.doingService.update(this.doing).subscribe(result => {
      if(result) {
        this.snackBar.open('Doing aktualisiert');
      } else {
        this.snackBar.open('Fehler beim aktualisieren des Doings');
      }
    });
  }

  public getLogo() {
    if(this.doing.cooperation != null && this.doing.cooperation.customer != null && this.doing.cooperation.customer.logo != null) {
      return this.doing.cooperation.customer.logo.filename;
    } else if(this.doing.customer != null && this.doing.customer.logo != null) {
      return this.doing.customer.logo.filename;
    }
    return null;
  }

  public followUpDateChanged(date) {
    this.doingService.update({
      id: this.doing.id,
      followUp: dayjs(date.toDate()).toDate()
    }).subscribe(_ => {

    }, error => {
      this.snackBar.open('Fehler beim Aktualisieren des Follow-Up-Datums!');
    })
  }
}
